import { Box, Tab, Tabs } from '@mui/material';
import { MaTransactionsProvider, useMaTransactionsContext } from './MaTransactionsContext';
import React, { useEffect } from 'react';

import { Filters } from './components/Filters';
import { Notes } from './components/Notes';
import { TABS } from './constants';
import { useLocation } from 'react-router-dom';
import { useStyles } from './styles';

const MaPageInner = () => {
  const classes = useStyles();
  const { currentTab, setCurrentTab } = useMaTransactionsContext();
  const location = useLocation();

  const onTabChange = (newValue) => {
    setCurrentTab(newValue);
    // update URL hash
    window.location.hash = newValue;
  };

  useEffect(() => {
    // restore tab from URL hash
    const tag = location.hash.replace('#', '');
    // find the tab with the matching tag
    const tab = TABS.find((tab) => tab?.tag === tag);
    onTabChange(tab?.tag || TABS[0].tag);
  }, [location.hash]);

  // if no tab is selected, show nothing
  if (currentTab === null) return null;

  return (
    <Box className={classes.root}>
      <Box className={classes.content}>
        <Filters />
        <Box className={classes.contentWrapper}>
          <Tabs className={classes.tabs} value={currentTab} onChange={(_, tab) => onTabChange(tab)}>
            {TABS.map((tab, index) => (
              <Tab className={classes.tab} key={index} label={tab.label} value={tab.tag} />
            ))}
          </Tabs>

          {TABS.map((tab, index) => currentTab === tab.tag && <tab.component key={index} />)}
        </Box>
      </Box>
      <Notes />
    </Box>
  );
};

export const MaTransactionsPage = () => (
  <MaTransactionsProvider>
    <MaPageInner />
  </MaTransactionsProvider>
);
